// extracted by mini-css-extract-plugin
module.exports = {"HighlightBox":"HighlightBox--2Jcqf","HighlightBox-heading":"HighlightBox-heading--3tuCq","HighlightBox-content":"HighlightBox-content--1PFmd"};